import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueScrollmagic from 'vue-scrollmagic'
import VueScrollTo from 'vue-scrollto';
import AOS from 'aos'
import 'aos/dist/aos.css'
import Meta from 'vue-meta'
import VueGtm from '@gtm-support/vue2-gtm';
import store from './store'
import VueYoutubeEmbed from "vue-youtube-embed";

Vue.use(VueScrollmagic)
Vue.use(VueScrollTo)
Vue.use(VueYoutubeEmbed);
Vue.use(Meta)
Vue.use(VueGtm, {
  id: 'GTM-KZPHQ8M',
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});
Vue.config.productionTip = false
export const bus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    AOS.init()
  },
}).$mount('#app')
